'use client';

import React, { useMemo, useState } from 'react';
import { usePathname } from 'next/navigation';
import { type SnackbarStatesType } from 'ui/src/components/Snackbar';
import CookieBarComponent from './_CookieBar';
import CookieBarContext from './_context';

interface Props {
  children: React.ReactNode;
  excludedRoutes?: Set<string>;
}

export default function CookieBar({ children, excludedRoutes = new Set() }: Props) {
  const pathname = usePathname();
  const [cookieBarState, setCookieBarState] = useState<SnackbarStatesType>('Loading');
  const cookieBarContextValue = useMemo(
    () => ({ cookieBarState, setCookieBarState }),
    [cookieBarState, setCookieBarState],
  );

  if (pathname && excludedRoutes.has(pathname)) return children;

  return (
    <CookieBarContext.Provider value={cookieBarContextValue}>
      {children}
      <CookieBarComponent />
    </CookieBarContext.Provider>
  );
}
